export default "__VITE_ASSET__B0Iz1b0D__"